import { defineComponent as o, h as n, toRef as s, ref as r, onBeforeUnmount as f, nextTick as u } from "vue";
import v from "./highrise1729.mjs";
import c from "./highrise698.mjs";
const w = o({
  name: "BaseWave",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    c("-base-wave", v, s(t, "clsPrefix"));
    const l = r(null), i = r(!1);
    let e = null;
    return f(() => {
      e !== null && window.clearTimeout(e);
    }), {
      active: i,
      selfRef: l,
      play() {
        e !== null && (window.clearTimeout(e), i.value = !1, e = null), u(() => {
          var a;
          (a = l.value) === null || a === void 0 || a.offsetHeight, i.value = !0, e = window.setTimeout(() => {
            i.value = !1, e = null;
          }, 1e3);
        });
      }
    };
  },
  render() {
    const {
      clsPrefix: t
    } = this;
    return n("div", {
      ref: "selfRef",
      "aria-hidden": !0,
      class: [`${t}-base-wave`, this.active && `${t}-base-wave--active`]
    });
  }
});
export {
  w as default
};
